module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.forceCodeOnLogin && _vm.companyCode == null) ? _c('div', {
    staticClass: "account--wrapper dark login-page"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('div', {
    staticClass: "content login-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_enter_company_code')) + " " + _vm._s(_vm.forceCodeOnLogin))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyCodeModel),
      expression: "companyCodeModel"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_company_code'),
      "name": "companyCode"
    },
    domProps: {
      "value": (_vm.companyCodeModel)
    },
    on: {
      "keyup": _vm.companyCodeKeymonitor,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.companyCodeModel = $event.target.value
      }, _vm.onTextChange]
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "form-error"
  }, [_vm._v(_vm._s(_vm.backendError))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button-green medium",
    attrs: {
      "disabled": _vm.companyCodeLoading || !_vm.companyCodeModel
    },
    on: {
      "click": _vm.submitCompanyCode
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.companyCodeLoading ? _vm.locale.t('label_company_code_loading') : _vm.locale.t('label_company_code_confirm')) + "\n                    ")])])])])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.forceCodeOnLogin || _vm.companyCode != null) ? _c('div', {
    staticClass: "account--wrapper dark login-page"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('div', {
    staticClass: "content login-header"
  }, [_c('div', [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": _vm.logoImage
    }
  })]), _vm._v(" "), (_vm.forceCodeOnLogin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button-green",
    on: {
      "click": _vm.chooseCompany
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_company_code')))])])])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.companiesList.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_choose_company")))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompany),
      expression: "selectedCompany"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.companiesList), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                                          " + _vm._s(item.displayName) + "\n                                        ")])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_username')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.email),
      expression: "model.email"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "email",
      "placeholder": _vm.locale.t('label_username'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.email)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "validation-wrapper"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.errors.first('email')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_password')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.password),
      expression: "model.password"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "password",
      "placeholder": _vm.locale.t('label_password'),
      "name": "password"
    },
    domProps: {
      "value": (_vm.model.password)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "validation-wrapper"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.errors.first('password')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "form-error"
  }, [_vm._v(_vm._s(_vm.backendError))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button-green medium",
    attrs: {
      "disabled": !_vm.model.email || !_vm.model.password
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_do_login')) + "\n                                        ")])])])])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a17a5648!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/Login.vue
// module id = 835
// module chunks = 0